module.exports = __webpack_public_path__ + "static/giovanni-benussi-avatar-14851625d96ccda2c317db82114e64e5.jpg";